/**
 * 品牌单一来源 —— 改名只改这里。
 *
 * 备选名称（按推荐度）：
 *   1. 观象  —— 取自《易·系辞》「仰则观象于天，俯则观法于地」，涵盖三术而不局限于梅花
 *   2. 玄枢  —— 「玄机之枢」，更神秘，适合高端定位
 *   3. 知象  —— 更口语、更轻，适合大众化产品
 *   4. 易见  —— 双关「易」与「显而易见」，年轻化
 *
 * 英文名与拼音保持一致，避免与既有「MeiHua」商标/包名强绑定。
 */
export const BRAND = {
  name: '观象',
  seal: '观',
  english: 'GUANXIANG',
  tagline: 'AI 命理 · 观象知机',
  descriptor: '梅花 · 奇门 · 八字',
  version: '1.2.0',
} as const;
